export default "/assets/images/hepa.webp?a8a84a46d05451a4ff76d038e877ccf1";